var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRedshift = function SvgRedshift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0542 17.2918L19.6598 19.1027V4.85698L12.0542 6.66783V17.2918Z",
    fill: "#205B97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6598 4.85698L21.1084 5.58132V18.3783L19.6598 19.1027V4.85698ZM12.0542 17.2918L4.44867 19.1027V4.85698L12.0542 6.66783V17.2918Z",
    fill: "#5193CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44867 4.85698L3 5.58132V18.3783L4.44867 19.1027V4.85698Z",
    fill: "#205B97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9862 22L16.8835 20.5513V3.44867L13.9862 2L13.1004 11.4971L13.9862 22Z",
    fill: "#5193CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1223 22L7.22493 20.5513V3.44867L10.1223 2L11.0081 11.4971L10.1223 22Z",
    fill: "#205B97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1223 2H14.0254V21.9596H10.1223L10.1223 2Z",
    fill: "#2E73B7"
  })));
};

export { SvgRedshift as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjA1NDIgMTcuMjkxOEwxOS42NTk4IDE5LjEwMjdWNC44NTY5OEwxMi4wNTQyIDYuNjY3ODNWMTcuMjkxOFoiIGZpbGw9IiMyMDVCOTciLz4KPHBhdGggZD0iTTE5LjY1OTggNC44NTY5OEwyMS4xMDg0IDUuNTgxMzJWMTguMzc4M0wxOS42NTk4IDE5LjEwMjdWNC44NTY5OFpNMTIuMDU0MiAxNy4yOTE4TDQuNDQ4NjcgMTkuMTAyN1Y0Ljg1Njk4TDEyLjA1NDIgNi42Njc4M1YxNy4yOTE4WiIgZmlsbD0iIzUxOTNDRSIvPgo8cGF0aCBkPSJNNC40NDg2NyA0Ljg1Njk4TDMgNS41ODEzMlYxOC4zNzgzTDQuNDQ4NjcgMTkuMTAyN1Y0Ljg1Njk4WiIgZmlsbD0iIzIwNUI5NyIvPgo8cGF0aCBkPSJNMTMuOTg2MiAyMkwxNi44ODM1IDIwLjU1MTNWMy40NDg2N0wxMy45ODYyIDJMMTMuMTAwNCAxMS40OTcxTDEzLjk4NjIgMjJaIiBmaWxsPSIjNTE5M0NFIi8+CjxwYXRoIGQ9Ik0xMC4xMjIzIDIyTDcuMjI0OTMgMjAuNTUxM1YzLjQ0ODY3TDEwLjEyMjMgMkwxMS4wMDgxIDExLjQ5NzFMMTAuMTIyMyAyMloiIGZpbGw9IiMyMDVCOTciLz4KPHBhdGggZD0iTTEwLjEyMjMgMkgxNC4wMjU0VjIxLjk1OTZIMTAuMTIyM0wxMC4xMjIzIDJaIiBmaWxsPSIjMkU3M0I3Ii8+Cjwvc3ZnPgo=";